import { Enums } from '@cornerstonejs/core';

const BLEND_MODE_OPTIONS = [
	Enums.BlendModes.COMPOSITE,
	Enums.BlendModes.MAXIMUM_INTENSITY_BLEND,
	Enums.BlendModes.MINIMUM_INTENSITY_BLEND,
	Enums.BlendModes.AVERAGE_INTENSITY_BLEND
];

const DEFAULT_SLAB_THICKNESS = 15; // Default slab thickness for MIP mode

const BLEND_MODE_LABELS = new Map<Enums.BlendModes, string>([
	[Enums.BlendModes.COMPOSITE, 'MPR'],
	[Enums.BlendModes.MAXIMUM_INTENSITY_BLEND, 'MIP'],
	[Enums.BlendModes.MINIMUM_INTENSITY_BLEND, 'MinIP'],
	[Enums.BlendModes.AVERAGE_INTENSITY_BLEND, 'AvgIP']
]);

export { BLEND_MODE_LABELS, BLEND_MODE_OPTIONS, DEFAULT_SLAB_THICKNESS };
